var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C12 3.33579 11.6642 3 11.25 3C10.8358 3 10.5 3.33579 10.5 3.75V10.5H3.75C3.33579 10.5 3 10.8358 3 11.25C3 11.6642 3.33579 12 3.75 12H10.5V18.75C10.5 19.1642 10.8358 19.5 11.25 19.5C11.6642 19.5 12 19.1642 12 18.75V12H18.75C19.1642 12 19.5 11.6642 19.5 11.25C19.5 10.8358 19.1642 10.5 18.75 10.5H12V3.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new.ee029530222a79b0198dd10159d35d84.svg";